export const TaxesTypes = ["Real", "Presumido", "Simples"];
